import { get } from 'lodash';
import { IMaterializedReference } from '../../schema/expressions/evaluate/materializeReferencePath';
import { IHydrationContext } from '../IHydrationContext';

export function getHydratedReferenceValue(
  context: IHydrationContext,
  reference: IMaterializedReference,
) {
  if (reference.absolutePath.startsWith('$')) {
    return get(context.validationContext, reference.absolutePath.substring(1));
  }
  return get(context.values, reference.absolutePath);
}
